import React from 'react';
import styles from './StripeTestCheckout.module.scss';

const SimpleAddressForm = ({
  address1,
  setAddress1,
  address2,
  setAddress2,
  city,
  setCity,
  state,
  setState,
  zip,
  setZip,
  label = 'Address',
  disabled = false
}) => {
  return (
    <>
      <div className={styles.inputGroup}>
        <label htmlFor={`${label}_address1`} className={styles.label}>
          {label} Line 1
        </label>
        <input
          id={`${label}_address1`}
          type="text"
          value={address1}
          onChange={(e) => setAddress1(e.target.value)}
          className={styles.input}
          placeholder="123 Main St"
          required
          disabled={disabled}
        />
      </div>

      <div className={styles.inputGroup}>
        <label htmlFor={`${label}_address2`} className={styles.label}>
          {label} Line 2 (Optional)
        </label>
        <input
          id={`${label}_address2`}
          type="text"
          value={address2}
          onChange={(e) => setAddress2(e.target.value)}
          className={styles.input}
          placeholder="Apt, Suite, etc."
          disabled={disabled}
        />
      </div>

      <div className={styles.inputGroup}>
        <label htmlFor={`${label}_city`} className={styles.label}>
          City
        </label>
        <input
          id={`${label}_city`}
          type="text"
          value={city}
          onChange={(e) => setCity(e.target.value)}
          className={styles.input}
          placeholder="San Francisco"
          required
          disabled={disabled}
        />
      </div>

      <div className={styles.inputGroup}>
        <label htmlFor={`${label}_state`} className={styles.label}>
          State
        </label>
        <input
          id={`${label}_state`}
          type="text"
          value={state}
          onChange={(e) => setState(e.target.value)}
          className={styles.input}
          placeholder="CA"
          maxLength="2"
          required
          disabled={disabled}
        />
      </div>

      <div className={styles.inputGroup}>
        <label htmlFor={`${label}_zip`} className={styles.label}>
          ZIP Code
        </label>
        <input
          id={`${label}_zip`}
          type="text"
          value={zip}
          onChange={(e) => setZip(e.target.value)}
          className={styles.input}
          placeholder="94102"
          maxLength="10"
          required
          disabled={disabled}
        />
      </div>
    </>
  );
};

export default SimpleAddressForm;
